
export default function FloatPanel({ studioAccount }) {
  const t = useI18n()
  if (!studioAccount) return ''

  const openPrepayBooking = () => $openPrepayBooking({
    stylistId: studioAccount.id,
    stylistUserId: studioAccount.user.id,
    stylistName: studioAccount.user.name
  })

  return (
    <div className='w-full fixed bottom-0 py-5 md:hidden'
      style={ { zIndex: 1 } }
    >
      <div className='container'>
        <C.Blur><div className='py-8'/></C.Blur>
        <C.Button className='h-[2.8rem] md:h-[2.4rem]' fullWidth onClick={ openPrepayBooking }>{ t('page:studioId.book') }</C.Button>
      </div>
    </div>
  )
}
